import React, {useEffect, useRef, useState} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import './Dropdown.scss';

const Dropdown = ({ options, onSelect, selected, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelect = option => {
        setIsOpen(false);
        onSelect(option);
    };

    const handleClickOutside = event => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getOptionClassName = ({ value }) => classnames('dropdown__option', {
        selected: selected && selected.value === value,
    });

    return (
        <div className="dropdown" ref={dropdownRef}>
            <div className="dropdown__header" onClick={() => setIsOpen(!isOpen)}>
                {selected && selected.icon && <img className="dropdown__icon" src={selected.icon} alt="dropdown-icon"/>}
                <LocalizedText id={selected ? 'qau-dropdown-option-' + selected.value : (placeholder || 'qau-dropdown-default-text')} />
                <span className="dropdown__caret">{isOpen ? '▲' : '▼'}</span>
            </div>
            {isOpen && (
                <div className="dropdown__options">
                    {options.map(option => (
                        <div
                          key={option.value}
                          className={getOptionClassName(option)}
                          onClick={() => handleSelect(option)}
                        >
                            {option.icon && <img className='dropdown__icon' src={option.icon} alt='dropdown-icon' />}
                            <LocalizedText id={'qau-dropdown-option-' + option.value} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

Dropdown.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    onSelect: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    selected: PropTypes.object,
};

export default Dropdown;
